/* 劉備傳・第 7 章：赤壁・水陸並進（建安十三年，208）
 * 史實：《三國志·諸葛亮傳》諸葛亮說「事急矣，請奉命求救於孫將軍」，到柴桑說孫權「若能以吳、越之衆與中國抗衡，不如早與之絕」。
 *       《先主傳》：「權遣周瑜、程普等水軍數萬，與先主并力，與曹公戰於赤壁，大破之，焚其舟船。先主與吳軍水陸並進，追到南郡，時又疾疫，北軍多死，曹公引歸。」
 * 流程：1. 操作諸葛亮：在南岸見孫權，說服他與劉備聯手（孫吳傳「柴桑定策」的另一面）。
 *       2. 改操作劉備：火攻之後，從北岸東邊登陸，沿著江往西追擊撤退的曹軍；病倒的散兵可以站著招降，持械斷後的要打。
 *          關羽帶水軍在江上並進。搶在周瑜之前到南郡。 */
// @ts-nocheck
import { SG } from '../../core/sg.ts';
import { setLevel, ally, allyTick, swapPlayer, TROOPS } from '../kit.ts';
import { SHORE_N, CHAIN_Y } from '../maps/chibi.ts';

const LV = 12, LAND = [7600, 1000], NANJUN = [900, 850], RACE_T = 120;
const STRAG = [[6400, 900], [5200, 900], [3900, 900], [2700, 900]], GUARD = [[5800, 850], [3300, 850], [1800, 900]];
const fake = (x, y) => ({ x, y, f: -1, alive: true, input: {}, fake: true });

export default {
  id: 'liubei-7', map: 'chibi', hero: 'zhugeliang',
  title: '第 7 章　赤壁・水陸並進', year: '建安十三年（208）',
  brief: {
    quote: [{ text: '先主與吳軍水陸並進，追到南郡，時又疾疫，北軍多死，曹公引歸。', src: '《三國志·蜀書·先主傳》' }],
    text: '曹操南下，劉備退到夏口。諸葛亮自請出使江東，說服孫權聯手抗曹。（借東風、草船借箭是演義，放外傳。）',
    goals: ['諸葛亮：說服孫權', '劉備：沿北岸追擊，招降散兵', '搶在周瑜之前到南郡'],
  },
  words: { ally: '劉備軍', foe: '曹軍' },
  fuel(m, x, y) { return y < SHORE_N + 60 && y > 1150 && !SG.MAP.waterAt(x, y) && SG.MAP.walkable(x, y, 0); },
  spreadMul() { return 0.25; },
  stars: [
    { text: '搶在周瑜之前到南郡', ok: (m) => m.vars.arriveT != null && m.vars.arriveT < RACE_T },
    { text: '招降 8 人以上', ok: (m) => m.vars.got >= 8 },
    { text: '關羽的水軍沒有損失', ok: (m) => !m.vars.fleetLoss },
  ],
  steps: [
    { // 1. 說孫權
      enter(m, w) {
        const me = w.player, V = m.vars;
        setLevel(w, me, LV);
        me.x = 4300; me.y = 4500;
        V.quan = ally(w, 'sunquan', 4700, 4500, LV); V.quan.hold = [4700, 4500];
        V.lines = [['諸葛亮', '海內大亂，將軍起兵據有江東，劉豫州亦收衆漢南，與曹操並爭天下。'], ['諸葛亮', '若能以吳、越之衆與中國抗衡，不如早與之絕；若不能當，何不案兵束甲，北面而事之！'], ['孫權', '苟如君言，劉豫州何不遂事之乎？'], ['諸葛亮', '田橫，齊之壯士耳，猶守義不辱。況劉豫州王室之胄，英才蓋世，若事之不濟，此乃天也，安能復爲之下乎！'], ['孫權', '吾不能舉全吳之地，十萬之衆，受制於人。吾計決矣！']];
        V.li = 0; V.lt = -99;
        m.card('事急矣，請奉命求救於孫將軍。', '《諸葛亮傳》');
        m.mark('quan', 4700, 4500, '孫權');
        m.obj('talk', '見孫權，說服他聯手抗曹');
      },
      tick(m, w) {
        const me = w.player, V = m.vars;
        if (SG.gd(me.x, me.y, V.quan.x, V.quan.y) < 250 && w.t - V.lt > 3.5 && V.li < V.lines.length) { V.lt = w.t; const L = V.lines[V.li++]; m.line(L[0], L[1]); }
        return V.li >= V.lines.length && w.t - V.lt > 3;
      },
    },
    { // 2. 水陸並進
      enter(m, w) {
        const V = m.vars, kong = w.player;
        m.done('talk'); m.unmark('quan');
        m.card('權遣周瑜、程普等水軍數萬，與先主并力，與曹公戰於赤壁，大破之，焚其舟船。', '《先主傳》');
        m.wind = [-0.25, -0.97];
        for (let x = 2000; x <= 7200; x += 400) m.fire(x, SHORE_N - 60, { dps: 50, life: 20 });
        const lb = ally(w, 'liubei', LAND[0], LAND[1], LV);
        swapPlayer(w, lb);
        V.kong = kong; kong.x = -9999; kong.alive = false; kong.counted = true; // 諸葛亮留在南岸
        V.zf = ally(w, 'zhangfei', LAND[0] - 120, LAND[1] + 100, LV);
        V.men = Array.from({ length: 6 }, (_, i) => { const u = m.recruit(LAND[0] - 100 + (i % 3) * 60, LAND[1] + 150 + Math.floor(i / 3) * 70, '劉備軍'); u.spec = TROOPS.shu; m.join(u, lb); return u; });
        V.got = 0; V.t2 = w.t;
        V.strag = STRAG.map(([x, y], k) => { m.mark('s' + k, x, y, '病倒的散兵', true); return Array.from({ length: 3 }, (_, i) => { const u = m.foe('huangjin', x + (i - 1) * 60, y + (i % 2) * 40, { spec: TROOPS.wei, name: '曹軍散兵', hp: 260, maxHp: 260, atk: 10 }); u.asleep = true; u.home = [u.x, u.y]; return u; }); });
        V.guard = GUARD.flatMap(([x, y]) => Array.from({ length: 4 }, (_, i) => m.foe('huangjin', x + (i % 2) * 80, y + Math.floor(i / 2) * 100, { spec: TROOPS.wei, name: '曹軍斷後', hp: 480, maxHp: 480, atk: 28 })));
        V.fleet = [0, 1, 2].map((i) => m.boat(fake(7200 + i * 220, 2300 + i * 150), { x: 7200 + i * 220, y: 2300 + i * 150, flag: '#3e7b50', sp: 70, big: i === 0 }));
        for (const b of V.fleet) b.goal = [600, b.y];
        m.after(2, () => m.line('劉備', '曹軍潰了！沿北岸往西追，雲長的水軍在江上並進！'));
        m.after(5, () => m.line('提示', '病倒的曹軍散兵：站在他們旁邊就能招降；持械斷後的要打。搶在周瑜之前到南郡。'));
        m.mark('nanjun', NANJUN[0], NANJUN[1], '南郡');
        m.obj('race', '');
      },
      tick(m, w) {
        const me = w.player, V = m.vars, left = RACE_T - (w.t - V.t2);
        m.get('race').text = left > 0 ? `搶在周瑜之前到南郡（${Math.ceil(left)} 秒）` : '周瑜已經先到南郡了……';
        V.strag.forEach((g, k) => {
          if (!g.some((u) => u.alive && u.team === 1)) return;
          for (const u of g) if (u.alive && u.asleep) { u.target = null; u.think = 0.5; } // 病倒的散兵不還手
          const c = g.find((u) => u.alive);
          m.chanAt(me, 's' + k, c.x, c.y, 140, 1.5, '招降', () => {
            m.unmark('s' + k);
            for (const u of g) if (u.alive) { u.team = 0; u.asleep = false; u.recruit = true; u.target = null; u.home = null; u.spec = TROOPS.shu; u.name = '降卒'; m.join(u, me); V.got++; }
            m.line('曹軍散兵', '願降！願降！');
          });
        });
        return m.near(me, NANJUN[0], NANJUN[1], 320);
      },
    },
    { // 3. 追到南郡
      enter(m, w) {
        const V = m.vars;
        V.arriveT = w.t - V.t2;
        m.done('race'); m.unmark('nanjun');
        m.card('追到南郡，時又疾疫，北軍多死，曹公引歸。', '《先主傳》');
        m.after(6, () => m.win());
      },
      tick() { return false; },
    },
  ],
  always(m, w) {
    const V = m.vars;
    if (!w.player.alive) { m.lose(m.i >= 1 ? '劉備陣亡' : '諸葛亮陣亡'); return; }
    if (V.zf) allyTick(w, V.zf, w.player);
    if (V.fleet && V.fleet.some((b) => !m.boats.includes(b))) V.fleetLoss = true;
  },
};
